module.exports = __webpack_public_path__ + "static/media/avatar-02@2x.855fd628.png";